<template>
  <div class="control-panel control-panel-trigger fds">
    <row class="panel-title">
      <column>
        <h4 class="dark">
          Control Panel
        </h4>
      </column>
      <suffix>
        <button class="btn-icon gravel-to-blue collapse-toolbox" @click="panelCollapse()" type="button">
          <span class="sr-only">Collapse/Reveal Toolbox</span>
          <span class="icon arrow-double"></span>
        </button>
      </suffix>
    </row>

    <scroll-area class="panel">

      <control-group group-name="Events" list-style>
        <li v-for="item in controlGroups">
          <button v-bind:key="index"
                  data-c-tooltip-class="control-panel-tooltip right"
                  :data-c-tooltip="item.name"
                  :aria-label="item.name"
                  v-bind:data-type="item.type"
                  v-bind:class="controlClasses"
                  @mousedown.left="drag">
            <icon v-bind:class="item.icon"></icon>
            <span class="name">{{ item.name }}</span>
          </button>
        </li>
      </control-group>

    </scroll-area>

  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import controlPanelDragMixin from "../../../common/mixins/drag/controlPanelDragMixin";
  import {Hash} from "../../../common/interfaces/hashInterfaces";
  import storeMapper from "../../../common/mixins/storeMappers/storeMapper";
  import {BuilderArea} from "../enums/builder-area";
  import ObjectModel from "../../../common/models/objectModel";
  import ObjectModelTriggerDefinition from "~/models/objectModelTriggers/objectModelTriggerDefinition";

  const objectModelStoreMixin = storeMapper('objectModelStore', {state: ['objectModel']});

  export default Vue.extend({
    components: {},
    mixins: [
      controlPanelDragMixin,
      objectModelStoreMixin,
    ],
    data: function () {
      return {
        controlGroups: ObjectModelTriggerDefinition.getControlGroups(),
        draggableClasses: ['om-trigger-draggable'],
        droppableClasses: ['om-trigger-droppable', 'model-builder'],
        dragArea: BuilderArea.triggers,
      };
    },
    computed: {
      controlClasses(): Hash<boolean> {
        return {
          'om-trigger-draggable': true
        };
      },
      targetRoot(): ObjectModel {
        return this.objectModel;
      }
    },
  });
</script>